// extracted by mini-css-extract-plugin
export default {"liveItem":"index_liveItem_9lTn3","liveTime":"index_liveTime_g1ZTm","liveText":"index_liveText_-e3Sc"};